import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class PessoaJuridica extends BaseEntity {
  nome: string;
  sigla: string;
  cnpj: string;
}
